import React, { FC, useEffect, useState } from 'react';

import isEqual from 'lodash/isEqual';

import DesktopSidebar from '~/components/layouts/MainLayout/DesktopSidebar';
import MobileSidebarHeader from '~/components/layouts/MainLayout/MobileSidebarHeader';
import { sidebar, SideBarItemType } from '~/core/sidebar';
import { useIsViewport, Viewports } from '~/hooks/useIsViewport';
import { useAppSelector } from '~/store/hooks/useAppSelector';

type Props = {
  children?: React.ReactNode;
};

const MainLayoutSimple: FC<Props> = ({ children }) => {
  const profile = useAppSelector(
    (state) => state.profile,
    (state1, state2) => !isEqual(state1, state2),
  );
  const [sidebarGroups, setSidebarGroups] = useState<SideBarItemType[][]>(
    Object.values(sidebar.getAvailableItems(profile)),
  );
  const isDesktop = useIsViewport(Viewports.EXTRA_SMALL_DESKTOP);

  useEffect(() => {
    const unsubscribe = sidebar.subscribe(() => {
      setSidebarGroups(Object.values(sidebar.getAvailableItems(profile)));
    });

    return (): void => {
      unsubscribe();
    };
  }, []);

  const Layout = !isDesktop ? MobileSidebarHeader : DesktopSidebar;

  return <Layout sidebarGroups={sidebarGroups}>{children}</Layout>;
};

export default MainLayoutSimple;
